module.exports = __webpack_public_path__ + "static/media/hamburger-icon-white.40ccea3e.svg";